import { AlertCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const ErrorScreen = ({ error, onBack, onRetry }) => {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-green-50 via-white to-blue-50">
      <div className="text-center max-w-md p-8 bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl">
        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-red-100 to-pink-100">
          <AlertCircle className="w-8 h-8 text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Ops! Algo deu errado</h2>
        <p className="text-lg text-gray-600 mb-8">{error}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button 
            className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-2xl font-semibold transition-all transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2"
            onClick={onBack}
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar
          </button>
          <button 
            className="px-6 py-3 bg-gradient-to-r from-green-600 to-green-600 hover:from-green-700 hover:to-green-700 text-white rounded-2xl font-semibold transition-all transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 shadow-lg"
            onClick={onRetry}
          >
            <RefreshCw className="w-5 h-5" />
            Tentar Novamente
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorScreen;